"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitter = void 0;

var Enums_1 = require("../../../../Enums");

var EmitterRate_1 = require("./EmitterRate");

var EmitterLife_1 = require("./EmitterLife");

var Utils_1 = require("../../../../Utils");

var EmitterSize_1 = require("./EmitterSize");

var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    this.direction = Enums_1.MoveDirection.none;
    this.life = new EmitterLife_1.EmitterLife();
    this.rate = new EmitterRate_1.EmitterRate();
  }

  _createClass(Emitter, [{
    key: "load",
    value: function load(data) {
      if (data !== undefined) {
        if (data.size !== undefined) {
          if (this.size === undefined) {
            this.size = new EmitterSize_1.EmitterSize();
          }

          this.size.load(data.size);
        }

        if (data.direction !== undefined) {
          this.direction = data.direction;
        }

        this.life.load(data.life);

        if (data.particles !== undefined) {
          this.particles = Utils_1.Utils.deepExtend({}, data.particles);
        }

        this.rate.load(data.rate);

        if (data.position !== undefined) {
          this.position = {
            x: data.position.x,
            y: data.position.y
          };
        }
      }
    }
  }]);

  return Emitter;
}();

exports.Emitter = Emitter;